import styled, { keyframes } from 'styled-components';
import { MiniLogo } from '../../assets'

const fadeIn = keyframes`  
  0% { opacity: 0 }
  100% { opacity: 1 }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Amorim Sans Book', sans-serif;
  font-size: 24px;
  letter-spacing: 0.5px;
  color: #1D3739;
  padding: 16px 0 16px 0;

  @media (min-width: 768px) {
    padding: 40px 50px 20px 50px;
  }

  @media (min-width: 768px) and (max-height: 700px){
    padding: 30px 15px;
  }
` 

export const FormContainer = styled.div`
  width: 100%;
  max-width: 240px;
  height: 44px;
  border-top: solid 1px #1A1919;

  @media (min-width: 768px) {
    max-width: 396px;
  }

  @media (min-width: 768px) and (max-height: 700px){
    max-width: 300px;
  }
`

export const Form = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
`

export const ContainerSearchIcon = styled.div`
  width: 34px;
  height: 34px;
  svg {
    margin-bottom: 10px;
    cursor: pointer;
    height: 21px;
    width: 21px;
    transform: scaleX(-1) translateX(-2px) rotate(4deg);
  }

  @media (min-width: 768px) {
    width: 44px;
    height: 44px;
    padding-top: 4px;
    svg {
      margin-bottom: 0;
      transform: scaleX(-1) translateX(4px) rotate(4deg);
      height: 36px;
      width: 36px;
    }
  }
  @media (min-width: 768px) and (max-height: 700px){
    svg {
      margin-bottom: 0;
      transform: scaleX(-1) translateX(4px) rotate(4deg);
      height: 28px;
      width: 28px;
    }
  }
`

export const InputText = styled.input`
  margin-left: 14px;
  border: none;
  outline: none;
  background: transparent;
  text-align: right;
  letter-spacing: .5px;
  font-size: 14px;

  &::placeholder{
    color: #1D3739;
  }

  @media (min-width: 768px) {
    font-size: 24px;
    width: calc(100% - 44px);
    margin-left: 0;
    text-align: left;
  }

  @media (min-width: 768px) and (max-height: 700px){
    font-size: 18px;
  }
`

export const ReturnMobile = styled.div`
  width: 40px;
  height: 40px;

  svg {
    margin-left: -6px;
    margin-bottom: 14px;
  }

  @media (min-width: 768px) { display: none; }
`

export const Contador = styled.div`
  padding-top: 5px;
  height: 44px;
  min-width: 240px;
  display: flex;
  opacity: 0;

  animation-name: ${fadeIn};
  animation-duration: .5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;

  @media (max-width: 767px) {
    display: none;
  }
`

export const ContadorText = styled.p`
  text-align: right;
  @media (min-width: 768px) and (max-height: 700px){
      width: 100%;
      font-size: 18px;
  }
`

export const MiniLogoContainer = styled.div`
  position: absolute;
  top: 39px;
  left: 0;
  right: 0;
  margin-left: auto; 
  margin-right: auto; 
  width: 44px;
  height: 44px;
  background: url(${MiniLogo}) no-repeat center center;
  display: none;

  @media (max-width: 767px) {
    display: none;
  }
`

export const CloseButton = styled.div`
  width: 44px;
  height: 44px;
  margin-left: 6px;
  cursor: pointer;

  &.mobile {
    height: 34px;
    margin-left: 0px;

    svg {
      margin-bottom: 8px;
    }

    @media (min-width: 768px) {
      display: none;
    }
  }

  svg {
    margin-bottom: 4px;
  }
`